export default "__VITE_ASSET__BuVY1cX8__"